module.exports = __webpack_public_path__ + "img/kitchen-knife.7c0b2612.png";